var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#5c4e8c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10h20v30h-20z",
    fill: "#8e78b7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm-15 5h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm-15 5h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm-15 5h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm-15 5h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm-15 5h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm-15 5h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5zm5 0h5v5h-5z",
    fill: "#5c4e8c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15h10v5h-10zm5 10h5v5h-5zm-5 0h5v5h-5z",
    fill: "#ff6b97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30h5v5h-5zm5 0h5v5h-5z",
    fill: "#fbff86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel);
export default __webpack_public_path__ + "static/media/pixel.2cb95615183da6c90a8f2a1085f4c137.svg";
export { ForwardRef as ReactComponent };